<template>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>我的实验</span>
      </div>
      <div class="myExp">
            <div class="headerBut">
                <div class="elrow">
                    <el-row>
                        <el-button type="warning" size="small" icon="el-icon-plus" @click="addEx">添加实验</el-button>
                    </el-row>
                </div>
                <div class="elinput">
                    <el-input placeholder="输入实验名称进行搜索" clearable v-model="search" @keyup.enter.native="searchto" class="input-with-select">
                            <el-button slot="append" @click="searchto" style="border-top:1px solid #DCDFE6;"><i><img src="../../../assets/images/portal/magnifier.png" alt=""></i></el-button>
                            <el-button slot="append" icon="el-icon-refresh-left" @click="Rescreening" style="border-left:1px solid #DCDFE6;"></el-button>
                    </el-input>
                </div>
            </div>
            <div class="list">
                <div class="noshow" v-if="dataList == ''">
                    <span>快去创建实验吧</span>
                    <p><img src="../../../assets/images/portal/noex.png" alt=""></p>
                </div>
                <div class="item" v-for="(item,index) in dataList" :key="index" v-loading="loading">
                    <div class="pic" @click="infoex(item)">
                        <el-image fit="cover"  :src="item.sypicpath" :title="item.syname">
                            <div slot="error" class="image-slot">
                                <img src="../../../assets/images/portal/nophoto.png">
                            </div>
                        </el-image>
                        <!-- <img :src="item.fileThumbnail" :alt="item.title" :title="item.explanatoryNote" @error="errorUserPhoto"> -->
                        <div class="pichover" v-if="false">开始实验</div>
                        <!-- <div class="tbtj" :class="{'box3':item.isStudy == 1}">
                            <b class="left-top">{{item.isStudy | isStudy}}</b>
                        </div> -->
                        <!-- <div class="box" :class="{'box2':item.collectFees==1}">
                            <b class="right-top">{{item.collectFees | isCollectFees}}</b>
                        </div> -->
                    </div>
                    <h5 class="titl">{{item.syname}}</h5>
                    <div class="pick">
                        <el-dropdown size="small" @command="handleCommand(item)" placement='top'>
                            <span class="el-dropdown-link">
                                <i class="el-icon-more"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>删除实验</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
            <div class="paginations">
                <el-pagination
                    background
                    hide-on-single-page
                    layout="prev, pager, next"
                    :total="pageData.total"
                    @current-change="pageChange"
                    :current-page.sync="page"
                    :page-size='12'
                    >
                </el-pagination>
            </div>
      </div>
        <div id="unitybox" v-if="unityex">
            <div id="bo">
            <div id="buttombox">
                <el-tooltip class="items" effect="light" :popper-class="toolTipClass" content="关闭实验" placement="right" :open-delay="200">
                    <p id="closeun" @click="closeuni" style="cursor: pointer;float:left"><i><img src="../../../assets/images/portal/close.png" alt=""></i></p>
                </el-tooltip>
                <el-tooltip class="items" effect="light" :popper-class="toolTipClass" content="全屏显示" placement="right" :open-delay="200">
                    <div id="full" @click="fullSrc" style="cursor: pointer;float:left"><i><img src="../../../assets/images/portal/full.png" alt=""></i></div>
                </el-tooltip>
            </div>
                <iframe id="ifrunity" frameborder=0 scrolling=auto allowtransparency="true" :src="'http://221.231.139.161:8093/WebSite/syplay2.html?'+'&Authorization='+$store.state.user.token+'&SyName='+ this.exName2+'&config='+this.config+'&userid='+this.userid+'&syID='+this.syID+'&resourceid='+this.infoId"></iframe>
            </div>
        </div>
      <transition name="el-zoom-in-center">
        <div class="box" v-if="boxEx">
            <div class="transition-box">
                <div class="head">创建实验<p class="el-icon-close" @click="closea"></p></div>
                <div class="content">
                    <ul>
                        <li>实验名称：<el-input class="Exinput" v-model="exName" placeholder="请输入实验名称"></el-input></li>
                        <li>实验模块：
                            <el-radio-group v-model="modular" size="mini">
                                <el-radio label="1" border>电学</el-radio>
                                <el-radio label="2" border disabled>力学</el-radio>
                                <el-radio label="3" border disabled>光学</el-radio>
                                <el-radio label="4" border disabled>化学</el-radio>
                            </el-radio-group>
                        </li>
                        <!-- <li>关键词：<el-input v-model="exCrux" placeholder="请输入关键词"></el-input></li> -->
                        <li>添加知识点属性：
                            <el-button @click="getData(filedR)">添加<i class="el-icon-plus" style="margin-left:4px;"></i></el-button>
                                <el-cascader
                                    :checkStrictly="true"
                                    ref="scalectz"
                                    v-model="filedR.label"
                                    :options="data"
                                    :props="defaultProps"
                                    @change="change"
                                    :change-on-select="true"
                                    >
                                </el-cascader>
                            <!-- <template slot-scope="scope"> -->
                            <div v-for="(item,index) in filedR" :key="index">
                                <el-cascader
                                    :checkStrictly="true"
                                    ref="scal"
                                    v-model="item.label"
                                    :options="data"
                                    :props="defaultProps"
                                    @change="change22(item,index)"
                                    :change-on-select="true"
                                    >
                                </el-cascader>
                                <el-button type="text" @click="del(index)">删除</el-button>
                            </div>
                            <!-- </template> -->
                            <!-- <el-tree
                                v-loading="loading"
                                :data="data"
                                show-checkbox
                                accordion
                                ref="treez"
                                check-strictly
                                node-key="id"
                                :props="defaultProps"
                                @check-change="handleNodeClickz">
                            </el-tree> -->
                        </li>
                        <li>添加章节属性：
                            <el-button @click="getData2(filedR2)">添加<i class="el-icon-plus" style="margin-left:4px;"></i></el-button>
                                <el-cascader
                                    :checkStrictly="true"
                                    ref="scalectj"
                                    v-model="filedR2.label"
                                    :options="data2"
                                    :props="defaultProps2"
                                    @change="change2"
                                    :change-on-select="true"
                                    >
                                </el-cascader>
                            <div v-for="(item,index) in filedR2" :key="index">
                                <el-cascader
                                    :checkStrictly="true"
                                    ref="scal2"
                                    v-model="item.label"
                                    :options="data2"
                                    :props="defaultProps2"
                                    @change="change32(item,index)"
                                    :change-on-select="true"
                                    >
                                </el-cascader>
                                <el-button type="text" @click="del2(index)">删除</el-button>
                            </div>
                            <!-- <el-tree
                                v-loading="loading"
                                :data="data2"
                                show-checkbox
                                check-strictly
                                accordion
                                ref="treej"
                                node-key="id"
                                :props="defaultProps2"
                                @check-change="handleNodeClickj">
                            </el-tree> -->
                        </li>
                        <li>
                            <el-button :loading="loading" type="warning" @click="preserCon">创建</el-button>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
      </transition>
    </el-card>
</template>

<script>
import request from '@/utils/request'
import { log } from 'util';

export default {
    data(){
        return{
            loading: false,
            filedR:[],
            filedR2:[],
            syID:0,
            config:'',
            //tooltip提示文字
            toolTipClass: 'page-login-toolTipClass',
            dataList:[{}],
            appIDX:'',
            strReady:'',
            titleNameKey:'',
            userid:0,
            pageData:{
                currentPage:1,
                pagesize:12,
                pagenumber:0,
                total:0,
                average:0,
            },
            page:0,
            // el-tree
            eduIdj:0,
            eduIdz:0,
            ed:[],
            ed2:[],
            data: [],
            cascaderz:[],
            data2: [],
            loading:false,
            nums:0,
            nums2:0,
            defaultProps: {
                value:'id',
                children: 'children',
                label: 'chapterName'
            },
            defaultProps2: {
                value:'id',
                children: 'children',
                label: 'chapterName'
            },
            // 实验模块
            modular:"1",
            // 添加实验
            exName:'',
            // 实验弹框
            boxEx:false,
            //搜索框
            search: '',
            unityex:false,
        }
    },
    created(){
        this.getTrees();
        this.getChapterTrees();
        this.getinfo();
        this.getConfig();
    },
    methods:{
        // 删除实验
        handleCommand(item){
            this.$confirm('是否删除该实验, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'messageBox-prompt-test',
            }).then(() => {
                request({
                    method:'delete',
                    url:'api/jdSylistinfo/'+item.id
                }).then(res=>{
                    this.$notify({
                        message: '删除实验成功',
                        type: 'success',
                        duration: 1500
                    })
                    this.getList()
                })
            }).catch(() => {
            })
        },
        cc2(){
            let num2 = this.eduIdj + ',' + this.ed2
            this.nums2 = num2
        },
        cc(){
            let num = this.eduIdz + ',' + this.ed
            this.nums = num
        },
        change22(item,index){
            let sszz = this.$refs.scal[index].getCheckedNodes()[0].value
            this.ed = sszz
            this.cc()
        },
        change32(item,index){
            let sszz2 = this.$refs.scal2[index].getCheckedNodes()[0].value
            this.ed2 = sszz2
            this.cc2()
        },
        // 知识点选择
        change(value){
            let ss = this.$refs.scalectz.getCheckedNodes()[0].value
            this.eduIdz = ss
            this.cc()
        },
        // 章节选择
        change2(value){
            let ss2 = this.$refs.scalectj.getCheckedNodes()[0].value
            this.eduIdj = ss2
            this.cc2()
        },
        // 知识点选择
        getData(filedR){
            if(filedR.length>0){
                this.$notify({
                    message: '知识点只能添加两个哦！',
                    type:'error',
                    duration: 1500
                })
            }else{
                this.filedR.push({})
            }
        },
        // 章节选择
        getData2(filedR2){
            if(filedR2.length>0){
                this.$notify({
                    message: '章节只能添加两个哦！',
                    type:'error',
                    duration: 1500
                })
            }else{
            this.filedR2.push({})
            }
        },
        // 知识点选择
        del(index){
            this.ed = '';
            this.cc();
            this.filedR.splice(index,1);
        },
        // 章节选择
        del2(index){
            this.ed2 = '';
            this.cc2();
            this.filedR2.splice(index,1);
        },
        // 全屏显示
        fullSrc(element){
            var element = document.getElementById("ifrunity");
            if(element.requestFullscreen){
                return element.requestFullscreen();
            }else if(element.webkitRequestFullScreen){
                return element.webkitRequestFullScreen();
            }else if(element.mozRequestFullScreen){
                return element.mozRequestFullScreen();
            }else{
                return element.msRequestFullscreen();
            }
            // var element = document.getElementById("ifrunity");
            // element.requestFullscreen();
        },
        // 关闭实验
        closeuni(){
            this.$confirm('此操作将关闭当前实验, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'messageBox-prompt-test',
            }).then(() => {
                this.unityex = false;
                this.getList();
            }).catch(() => {
                this.unityex = true;
            })
        },
        // 获取config信息
        getConfig(){
            request({
                method:'get',
                url:'api/getConfiguration?'+'version=v1.1'
            }).then(res=>{
                if(res.code == 200){
                    this.config = res.data
                }else{
                    this.$notify({
                        message: 'config获取失败',
                        type: 'error',
                        duration: 1500
                    })
                }
            })
        },
        // 点击实验
        infoex(item){
            if(true){
                this.syID = item.id
                this.userid = this.userid
                this.exName2 = item.syname
                this.unityex = true
            }
        },
        //获取用户自己实验
        getList(type){
            request({
                 method:'get',
                 url: 'api/jdSylistinfo?'+'page='+this.pageData.pagenumber+'&size='+this.pageData.pagesize+'&syuserid='+this.userid+'&syname='+this.search+'&sort=id,desc'+'&userCollect=0'
            }).then(res=>{
                this.dataList = res.data.content;
                var temp = {}
                temp.pagesize=this.pageData.pagesize;
                temp.pagenumber=this.pageData.pagenumber;
                temp.total =Number(res.data.totalElements);
                this.pageData=temp
                this.loading = false
            })
        },
        pageChange(data){
            this.pageData.pagenumber = data-1;
            this.getList()
        },
        //获取到info
        getinfo(){
          request({
            method:'get',
            url:'auth/info'
          }).then(res=>{
            this.userid = res.jwtUser.id
            // this.getinfos = res.us.edu_treeid
            this.getList()
          })
        },
        //获取侧边栏:按知识点
        getTrees(){
            var _this = this;
            _this.loading=true;
            request({
                url: 'api/trees/trees?'+'noderes=0',
                methods: 'get'
            }).then(function(res){
                _this.data = res.data;
                _this.loading=false
            })
        },
        //获取侧边栏:章节
        getChapterTrees(){
            var _this = this;
            _this.loading=true;
            request({
                url: 'api/chaptertrees/chaptertrees?'+'noderes=0',
                methods: 'get'
            }).then(function(res){
                _this.data2 = res.data;
                _this.loading=false
            })
        },
        //   知识点
        handleNodeClickz() {
          this.eduIdz = []
            let takeDate = this.$refs.treez.getCheckedNodes();
            for(let i in takeDate){
                this.eduIdz.push(takeDate[i].id)
            }
        },
        //   章节
        handleNodeClickj() {
          this.eduIdj = []
            let takeDate = this.$refs.treej.getCheckedNodes();
            for(let i in takeDate){
                this.eduIdj.push(takeDate[i].id)
            }
        },
        // 保存实验信息
        preserCon(){
            this.loading = true
            if(true){
                request({
                    // url:'https://yunwei.judaoedu.com:8055/api/oauth/getkey'
                    // url:'http://221.231.139.161:8066/api/oauth/getkey'
                    // method:'post',
                    // url:'api/Oauth/GetKey'
                }).then(res=>{
                    if(res.code == 400){
                        this.$notify({
                            message: '创建实验有误，请联系管理员',
                            type: 'error',
                            duration: 1500
                        })
                        this.eduIdz = 0
                        this.eduIdj = 0
                        this.exName = ''
                        this.filedR.label = 0
                        this.filedR2.label = 0
                        this.nums = 0;
                        this.nums2 = 0;
                        this.del();
                        this.del2();
                        this.boxEx = false;
                    }else{
                        this.appIDX = res.data.appidx
                        this.strReady = res.data.strread
                        this.titleNameKey = res.data.titlename
                        if(this.appIDX == ''&&this.strReady == ''&&this.titleNameKey == ''){
                            this.$notify({
                                message: '创建实验有误，请联系管理员',
                                type: 'error',
                                duration: 1500
                            })
                            this.eduIdz = 0
                            this.eduIdj = 0
                            this.exName = ''
                            this.filedR.label = 0
                            this.filedR2.label = 0
                            this.nums = 0;
                            this.nums2 = 0;
                            this.del();
                            this.del2();
                            this.boxEx = false;
                        }else{
                            let syName = {}
                            syName.syname = this.exName
                            syName.syuserid = this.userid
                            if(syName.syname == ''){
                                this.$notify({
                                    message:'您还未填写实验名称哦！',
                                    type:'error',
                                    duration: 1500
                                })
                            }else{
                                request({
                                    method:'post',
                                    url:'api/addJdSylistinfo?'+'appIDX='+this.appIDX+'&chapterIds='+this.nums2+'&strReady='+encodeURIComponent(this.strReady)+'&titleNameKey='+this.titleNameKey+'&treeIds='+this.nums,
                                    data:syName
                                }).then(res=>{
                                    if(res.code == 400){
                                        this.$notify({
                                            message: '创建实验有误，请联系管理员',
                                            type: 'error',
                                            duration: 1500
                                        })
                                        this.eduIdz = 0
                                        this.eduIdj = 0
                                        this.filedR.label = 0
                                        this.filedR2.label = 0
                                        this.nums = 0;
                                        this.nums2 = 0;
                                        this.del();
                                        this.del2();
                                        this.exName = ''
                                        this.boxEx = false;
                                    }else{
                                        this.$notify({
                                            message: '创建实验成功',
                                            type: 'success',
                                            duration: 1500
                                        })
                                        this.loading = false;
                                        this.getList();
                                        this.del();
                                        this.del2();
                                        this.filedR.label = 0
                                        this.filedR2.label = 0
                                        this.nums = 0;
                                        this.nums2 = 0;
                                        this.exName = ''
                                        this.boxEx = false;
                                    }
                                })
                            }
                        }
                    }
                })
            }
        },
        // 关闭实验框
        closea(){
            this.$confirm('此操作将会关闭此页面, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'messageBox-prompt-test',
                }).then(() => {
                    this.boxEx = false
                    this.eduIdz = 0
                    this.eduIdj = 0
                    this.filedR.label = 0
                    this.filedR2.label = 0
                    this.nums = 0;
                    this.nums2 = 0;
                    this.del();
                    this.del2();
                    this.exName = ''
                }).catch(() => {
            });
        },
        // 添加实验
        addEx(){
            this.boxEx = true
        },
        // 搜索框
        searchto(){
            var specialKey = "[`@~!#$^&*()=|%{}':;',[].<>/~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
            for(var i = 0;i<specialKey.length;i++){
                if(this.search == specialKey[i]){
                    this.$notify({
                        message:"此为非法字符，请确认后输入",
                        type:'error',
                        duration: 1500
                    })
                    return
                }
            }
            this.pageData.pagenumber = 0;
            this.getList();
        },
        Rescreening(){
            this.$confirm('此操作将会清除输入框内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'messageBox-prompt-test',
            }).then(() => {
                this.search = '';
                let page = {}
                page.pagesize = 12;
                page.pagenumber = 0;
                page.currentPage = 1;
                page.total = 0;
                page.search = '';
                this.pageData =page
                this.getList()
            }).catch(() => {      
            });
        },
    }
}
</script>

<style scoped>
    #unitybox{
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 2001;
    }
    #bo{
        position: relative;
        left: 50%;
        top: 50%;
        right: 0;
        bottom: 0;
        transform: translateX(-50%) translateY(-50%);
        width:640px;
        height:360px;
    }
    #ifrunity{
        width:100%;
        height: 100%;
    }
    .myExp{
        float: left;
        width: 100%;
        height: 100%;
    }
    .headerBut{
        float: left;
        width: 100%;
        padding: 20px 20px 0 20px;
        margin-bottom: 16px;
    }
    .elrow{
        float: left;
    }
    .elinput{
        float: right;
        width: auto;
    }
    .elinput /deep/ .el-input--suffix .el-input__inner{
        font-size: 16px;
        color: #a0a0a0;
        background-color: #f6f6f6;
    }
    .elinput /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
    .elinput /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
        border-top: none !important;
    }
    .box{
        position: fixed;
        left: 0;
        right: 0;
        top:0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .4);
        z-index:2001;
    }
    .transition-box{
        width: 666px;
        /* height: auto; */
        height: 560px;
        position:absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        background-color: #fff;
        padding-bottom: 20px;
        overflow: hidden;
        overflow-y: auto;
    }
    .head{
        height: 100px;
        line-height: 100px;
        text-align: center;
        position: relative;
        font-size: 26px;
        color: #333;
    }
    .head p{
        position: absolute;
        margin: 0;
        right: 0;
        text-indent: 0;
        font-size: 24px;
        margin:20px 20px 0 0;
        cursor: pointer;
        color: #999;
        font-weight: bold;
    }
    .content{
        width: 100%;
        height: auto;
        float: left;
        padding: 0 90px;
    }
    .content ul{
        margin: 0;
        padding: 0;
        float: left;
    }
    .content ul li{
        list-style: none;
        float: left;
        margin-bottom: 30px;
        font-size: 18px;
        color: #333;
        width:100%;
    }
    .content ul li:nth-of-type(3) .el-button{
        margin-left: 20px;
    }
    .content ul li:nth-of-type(3) .el-button:focus, .el-button:hover{
        border-color: #F38F38;
        color:#F38F38;
        background-color: #fff;
        border-radius: 2px;
    }
    .content ul li:nth-of-type(4) .el-button{
        margin-left: 20px;
    }
    .content ul li:nth-of-type(4) .el-button:focus, .el-button:hover{
        border-color: #F38F38;
        color:#F38F38;
        background-color: #fff;
        border-radius: 2px;
    }
    .content ul li:last-of-type{
        width: 100%;
        text-align: center;
        margin-bottom: 0;
    }
    .content /deep/ .el-button--warning{
        font-size: 18px !important;
        color: #fff !important;
        padding:12px 32px !important;
        background-color:#F38F38;
    }
    .content /deep/ .el-cascader .el-input.is-focus .el-input__inner{
        border-color: #F38F38;
    }
    .content /deep/ .el-cascader{
        width: 80%;
        height: 32px;
        margin-top: 14px;
    }
    .content /deep/ .el-cascader .el-input__inner{
        height: 32px;
        border-radius: 2px;
    }
    .content /deep/ .el-cascader .el-input__icon{
        line-height: 32px;
    }
    .content /deep/ .el-button{
        color:#F38F38;
        border-color:#F38F38;
        border-radius: 2px;
        padding: 5px 10px;
        font-size: 16px;
    }
    .content /deep/ .el-button--text{
        border:none;
        padding: 5px 0;
    }
    .content /deep/ .el-radio.is-bordered.is-checked{
        border-color: #F38F38;
        border: 2px solid #F38F38;
        background: url(../../../assets/images/portal/gou.png) no-repeat 95% 100%;
    }
    .content /deep/ .el-radio.is-bordered{
        border-color:#ccc;
    }
    .content /deep/ .el-radio--mini.is-bordered{
        padding: 8px 20px;
        height:auto;
    }
    .content /deep/ .el-radio--mini.is-bordered .el-radio__label, .el-radio--small.is-bordered .el-radio__label{
        font-size: 16px;
        color: #333;
        padding: 0;
    }
    .content /deep/ .el-radio__input.is-checked+.el-radio__label{
        color: #F38F38;
        padding: 0;
    }
    .content /deep/ .el-radio{
        margin-right: 10px;
    }
    .content /deep/ .el-radio__input{
        display: none;
    }
    .el-tree{
        margin-top: 10px;
        min-width: 100%;
        display: inline-block;
    }
    .el-input{
        width: 360px;
    }
    .Exinput{
        width: 376px;
    }
    .Exinput /deep/ .el-input__inner{
        height: 34px;
        /* border-radius: inherit; */
        border-color: #ccc;
    }
    /* 偏好 */
    .content /deep/ .el-checkbox__input.is-focus .el-checkbox__inner{
        border-color: #f1ad4e;
    }
    .content /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background-color: #f1ad4e;
        border-color: #f1ad4e;
    }
    .content /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background-color: #f1ad4e;
        border-color: #f1ad4e;
    }
    .content /deep/ .el-tree-node:focus>.el-tree-node__content{
        background-color: #fef7ed;
    }
    .content /deep/ .el-tree-node__content:hover{
        background-color: #fef7ed;
    }
    .content /deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
        background-color: #fef7ed;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 130px;
    }
    .noshow>span{
        font-size: 32px;
        color: #999;
    }
    .noshow>p{
        margin-top: 69px;
        margin-bottom: 150px;
        width: 593px;
        height: 349px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    .el-card /deep/ .el-card__body{
        height:auto;
    }
    .list /deep/ .image-slot{
        width:100%;
        height:100%;
    }
    .list{
        width: 100%;
        height: 100%;
    }
    .item{
        width:30%;
        float: left;
        margin: 1%;
        z-index: 10;
        transition: all 0.2s ease 0s;
        position: relative;
    }
    .item:hover{
        transition: all 0.2s linear 0s;
        transform: scale(1.01);
        box-shadow: 2px 2px 10px #888;
    }
    .item:hover .collection{
        display: block;
    }
    .pic{
        width: 100%;
        text-align: center;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        height: 192px;
    }
    .pic /deep/ .el-image{
        width:100%;
        height: 100%;
    }
    .pic img{
        width:100%;
        height: 100%;
    }
    .titl{
        padding-top: 17px;
        padding-left: 2%;
        padding-bottom: 0;
        font-size: 18px;
        color: #333;
        font-weight: 400;
        width: 94%;
        margin: 0;
        white-space:nowrap; text-overflow:ellipsis; -o-text-overflow:ellipsis; overflow:hidden;
    }
    .paginations{
        width: 100%;
        float: left;
        padding: 20px 20px;
        margin-bottom: 60px;
        position: relative;
    }
    .el-pagination{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        font-weight: 400;
    }
    .pick{
        float: right;
        margin: 0;
        color:#666;
    }
    .pick /deep/ .el-dropdown{
        color: #F38F38;
        transform: rotate(90deg);
        margin-bottom: 5px;
    }
    @media (max-width: 375px){
        .item{
            width:336px;
            float: left;
            margin: 2%;
        }
        .pic{
            height: 189px;
        }
        .paginations{
            padding: 20px 0;
        }
        .paginations>.el-pagination{
            width: 100%;
            padding: 0;
        }
        .contentl{
            width:97%;
            border-bottom: 1px solid #eee;
            height: 65px;
            margin-left: 10px;
            margin-bottom: 16px;
        }
        .break{
            display:none;
        }
        .rowtab2{
            position: absolute;
            left: 0px;
            font-size: 14px;
            margin-top: 32px;
            margin-left: 110px;
        }
        .contentl>ul{
            height: 65px;
            line-height: 65px;
            margin: 1px 10px 0 0;
            padding: 0;
            list-style: none;
            padding: 0;
            float: right;
        }
        .contentl>ul>li{
            width: auto;
            margin: 0;
            padding: 0;
            list-style: none;
        }
        /* 分页 */
        .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
            background:#f1ad4e;
            color: #fff;
        }
        /* 搜索框 */
        .contentl /deep/ .input-with-select>.el-input__inner{
            background: #f6f6f6;
            color: #a0a0a0;
            font-size: 14px;
        }
        .contentl /deep/ .el-input-group__append button.el-button{
            background-color: #fff;
        }
        /* main */
        .contentl /deep/ .buttontab2>.el-radio-button__inner{
            border: none;
            padding: 0;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
            color: #f1ad4e;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
            background: #fff;
            color: #f1ad4e;
            box-shadow: none;
        }
        .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
            border-left: none;
        }
        .contentl /deep/ .el-button+.el-button{
            margin-left: 20px;
        }
    }
    @media screen and (min-width:376px) and (max-width: 768px){
        .item{
            width:47%;
            float: left;
            margin: 1.5%;
        }
        .pic{
            height: 144px;
        }
        .contentl{
            width:97%;
            border-bottom: 1px solid #eee;
            height: 65px;
            margin-left: 10px;
            margin-bottom: 16px;
        }
        .break{
            display:none;
        }
        .rowtab2{
            position: absolute;
            left: 0px;
            font-size: 14px;
            margin-top: 32px;
            margin-left: 340px;
        }
        .contentl>ul{
            height: 65px;
            line-height: 65px;
            margin: 1px 0 0 0;
            padding: 0;
            list-style: none;
            padding: 0;
            float: right;
        }
        .contentl>ul>li{
            width: auto;
            float: left;
            margin: 0;
            padding: 0;
            list-style: none;
        }
        /* 分页 */
        .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
            background:#f1ad4e;
            color: #fff;
        }
        /* 搜索框 */
        .contentl /deep/ .input-with-select>.el-input__inner{
            background: #f6f6f6;
            color: #a0a0a0;
            font-size: 16px;
        }
        .contentl /deep/ .el-input-group__append button.el-button{
            background-color: #fff;
        }
        /* main */
        .contentl /deep/ .buttontab2>.el-radio-button__inner{
            border: none;
            padding: 0;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
            color: #f1ad4e;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
            background: #fff;
            color: #f1ad4e;
            box-shadow: none;
        }
        .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
            border-left: none;
        }
        .contentl /deep/ .el-button+.el-button{
            margin-left: 20px;
        }
        #unitybox{
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.4);
            z-index: 2001;
        }
        #bo{
            position: relative;
            left: 50%;
            top: 50%;
            right: 0;
            bottom: 0;
            transform: translateX(-50%) translateY(-50%);
            width:640px;
            height:360px;
        }
        #buttombox{
            position: absolute;
            top: 0;
            right: -51px;
            width: 51px;
            height: auto;
        }
        #full{
            float:left;
            margin: 0;
            padding:5px 15px 3px 15px;
            font-size:20px;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
        }
        #closeun{
            float:left;
            margin: 0;
            padding:5px 16px 3px 16px;
            font-size:20px;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
            cursor: pointer;
            border-bottom:2px solid #eee;
        }
    }
    @media screen and (min-width:769px) and (max-width: 1024px){
        .item{
            width:48%;
            float: left;
            margin: 1%;
        }
        .pic{
            height: 156px;
        }
        .contentl{
            width:97%;
            border-bottom: 1px solid #eee;
            height: 65px;
            margin-left: 10px;
            margin-bottom: 16px;
        }
        .break{
            display:none;
        }
        .rowtab2{
            position: absolute;
            left: 0px;
            font-size: 14px;
            margin-top: 32px;
            margin-left: 360px;
        }
        .contentl>ul{
            height: 65px;
            line-height: 65px;
            margin: 1px 0 0 0;
            padding: 0;
            list-style: none;
            padding: 0;
            float: right;
        }
        .contentl>ul>li{
            width: auto;
            float: left;
            margin: 0;
            padding: 0;
            list-style: none;
        }
        /* 分页 */
        .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
            background:#f1ad4e;
            color: #fff;
        }
        /* 搜索框 */
        .contentl /deep/ .input-with-select>.el-input__inner{
            background: #f6f6f6;
            color: #a0a0a0;
            font-size: 16px;
        }
        .contentl /deep/ .el-input-group__append button.el-button{
            background-color: #fff;
        }
        /* main */
        .contentl /deep/ .buttontab2>.el-radio-button__inner{
            border: none;
            padding: 0;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
            color: #f1ad4e;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
            background: #fff;
            color: #f1ad4e;
            box-shadow: none;
        }
        .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
            border-left: none;
        }
        .contentl /deep/ .el-button+.el-button{
            margin-left: 20px;
        }
        #unitybox{
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.4);
            z-index: 2001;
        }
        #bo{
            position: relative;
            left: 50%;
            top: 50%;
            right: 0;
            bottom: 0;
            transform: translateX(-50%) translateY(-50%);
            width:608px;
            height:342px;
        }
        #buttombox{
            position: absolute;
            top: 0;
            right: -51px;
            width: 51px;
            height: auto;
        }
        #full{
            float: left;
            padding:5px 15px 3px 15px;
            margin: 0;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
        }
        #closeun{
            float: left;
            padding:5px 16px 3px 16px;
            border-bottom:2px solid #eee;
            margin: 0;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
            cursor: pointer;
        }
    }
    @media screen and (min-width:1025px) and (max-width:1366px){
        .item{
            width:47%;
            float: left;
            margin: 1%;
        }
        .break{
            display:none;
        }
        .rowtab2{
            float: left;
            margin-left: 20px;
        }
        .contentl{
            width:97%;
            border-bottom: 1px solid #eee;
            height: 65px;
            margin-left: 10px;
            margin-bottom: 16px;
        }
        .pic{
            height: 252px;
        }
        .contentl>ul{
            height: 65px;
            line-height: 65px;
            margin: 0;
            padding: 0;
            list-style: none;
            float: right;
        }
        .contentl>ul>li{
            width: auto;
            float: left;
            margin: 0;
            padding: 0;
            list-style: none;
        }
        /* 提示信息 */
        .noshow{
            height: auto;
            text-align: center;
            margin-top: 95px;
        }
        .noshow>span{
            font-size: 24px;
            color: #999;
        }
        .noshow>p{
            margin-top: 49px;
            margin-bottom: 62px;
            width: 422px;
            height: 248px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
        }
        .noshow>p>img{
            width: 100%;
            height: 100%;
        }
        /* 分页 */
        .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
            background:#f1ad4e;
            color: #fff;
        }
        /* 搜索框 */
        .contentl /deep/ .input-with-select>.el-input__inner{
            background: #f6f6f6;
            color: #a0a0a0;
            font-size: 16px;
        }
        .contentl /deep/ .el-input-group__append button.el-button{
            background-color: #fff;
        }
        /* main */
        .contentl /deep/ .buttontab2>.el-radio-button__inner{
            border: none;
            padding: 0;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
            color: #f1ad4e;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
            background: #fff;
            color: #f1ad4e;
            box-shadow: none;
        }
        .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
            border-left: none;
        }
        .contentl /deep/ .el-button+.el-button{
            margin-left: 20px;
        }
        #unitybox{
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.4);
            z-index: 2001;
        }
        #bo{
            position: relative;
            left: 50%;
            top: 50%;
            right: 0;
            bottom: 0;
            transform: translateX(-50%) translateY(-50%);
            width:960px;
            height:540px;
        }
        #buttombox{
            position: absolute;
            top: 0;
            right: -51px;
            width: 51px;
            height: auto;
        }
        #full{
            float: left;
            padding:5px 15px 3px 15px;
            margin: 0;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
        }
        #closeun{
            float:left;
            padding:5px 16px 3px 16px;
            border-bottom:2px solid #eee;
            margin: 0;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
        }
    }
    @media screen and (min-width:1367px) and (max-width:1440px){
        .item{
            width:304px;
            float: left;
            margin: 0.8%;
        }
        .rowtab2{
            position: absolute;
            left: 200px;
            font-size: 14px;
            margin-top: 32px;
            margin-left: 710px;
        }
        .contentl{
            width:97%;
            border-bottom: 1px solid #eee;
            height: 65px;
            margin-left: 10px;
            margin-bottom: 16px;
        }
        .pic{
            height: 162px;
        }
        .contentl>ul{
            height: 65px;
            line-height: 65px;
            margin: 0;
            padding: 0;
            list-style: none;
            float: right;
        }
        .contentl>ul>li{
            width: auto;
            float: left;
            margin: 0;
            padding: 0;
            list-style: none;
        }
        /* 提示信息 */
        .noshow{
            height: auto;
            text-align: center;
            margin-top: 95px;
        }
        .noshow>span{
            font-size: 24px;
            color: #999;
        }
        .noshow>p{
            margin-top: 49px;
            margin-bottom: 62px;
            width: 422px;
            height: 248px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
        }
        .noshow>p>img{
            width: 100%;
            height: 100%;
        }
        /* 分页 */
        .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
            background:#f1ad4e;
            color: #fff;
        }
        /* 搜索框 */
        .contentl /deep/ .input-with-select>.el-input__inner{
            background: #f6f6f6;
            color: #a0a0a0;
            font-size: 16px;
        }
        .contentl /deep/ .el-input-group__append button.el-button{
            background-color: #fff;
        }
        /* main */
        .contentl /deep/ .buttontab2>.el-radio-button__inner{
            border: none;
            padding: 0;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
            color: #f1ad4e;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
            background: #fff;
            color: #f1ad4e;
            box-shadow: none;
        }
        .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
            border-left: none;
        }
        .contentl /deep/ .el-button+.el-button{
            margin-left: 20px;
        }
        #unitybox{
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.4);
            z-index: 2001;
        }
        #bo{
            position: relative;
            left: 50%;
            top: 50%;
            right: 0;
            bottom: 0;
            transform: translateX(-50%) translateY(-50%);
            width:960px;
            height:540px;
        }
        #buttombox{
            position: absolute;
            top: 0;
            right: -51px;
            width: 51px;
            height: auto;
        }
        #full{
            float: left;
            padding:5px 15px 3px 15px;
            margin: 0;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
        }
        #closeun{
            float:left;
            padding:5px 16px 3px 16px;
            border-bottom:2px solid #eee;
            margin: 0;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
        }
    }
    @media screen and (min-width:1441px) and (max-width:1600px){
        .item{
            width:336px;
            float: left;
            margin: 1%;
        }
        .rowtab2{
            position: absolute;
            left: 200px;
            font-size: 14px;
            margin-top: 32px;
            margin-left: 860px;
        }
        .contentl{
            width:97%;
            border-bottom: 1px solid #eee;
            height: 65px;
            margin-left: 10px;
            margin-bottom: 16px;
        }
        .pic{
            height: 189px;
        }
        .contentl>ul{
            height: 65px;
            line-height: 65px;
            margin: 0;
            padding: 0;
            list-style: none;
            float: right;
        }
        .contentl>ul>li{
            width: auto;
            float: left;
            margin: 0;
            padding: 0;
            list-style: none;
        }
        /* 提示信息 */
        .noshow{
            height: auto;
            text-align: center;
            margin-top: 117px;
        }
        .noshow>span{
            font-size: 26px;
            color: #999;
        }
        .noshow>p{
            margin-top: 55px;
            margin-bottom: 96px;
            width: 474px;
            height: 279px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
        }
        .noshow>p>img{
            width: 100%;
            height: 100%;
        }
        /* 分页 */
        .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
            background:#f1ad4e;
            color: #fff;
        }
        /* 搜索框 */
        .contentl /deep/ .input-with-select>.el-input__inner{
            background: #f6f6f6;
            color: #a0a0a0;
            font-size: 16px;
        }
        .contentl /deep/ .el-input-group__append button.el-button{
            background-color: #fff;
        }
        /* main */
        .contentl /deep/ .buttontab2>.el-radio-button__inner{
            border: none;
            padding: 0;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
            color: #f1ad4e;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
            background: #fff;
            color: #f1ad4e;
            box-shadow: none;
        }
        .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
            border-left: none;
        }
        .contentl /deep/ .el-button+.el-button{
            margin-left: 20px;
        }
        #unitybox{
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.4);
            z-index: 2001;
        }
        #bo{
            position: relative;
            left: 50%;
            top: 50%;
            right: 0;
            bottom: 0;
            transform: translateX(-50%) translateY(-50%);
            width:1120px;
            height:630px;
        }
        #buttombox{
            position: absolute;
            top: 0;
            right: -51px;
            width: 51px;
            height: auto;
        }
        #full{
            float:left;
            padding: 5px 15px;
            margin: 0;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
        }
        #closeun{
            float:left;
            border-bottom:2px solid #eee;
            padding: 5px 16px;
            margin: 0;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
        }
    }
    @media screen and (min-width:1601px) and (max-width:1920px){
        .item{
            width:352px;
            float: left;
            margin: 0.5%;
        }
        .contentl{
            width:97%;
            border-bottom: 1px solid #eee;
            height: 65px;
            margin-left: 10px;
            margin-bottom: 16px;
        }
        .contentl>ul{
            height: 65px;
            line-height: 65px;
            margin: 0;
            padding: 0;
            list-style: none;
            float: right;
        }
        .pic{
            height: 198px;
        }
        .rowtab2{
            position: absolute;
            left: 600px;
            font-size: 14px;
            margin-top: 32px;
            margin-left: 805px;
        }
        .contentl>ul>li{
            width: auto;
            float: left;
            margin: 0;
            padding: 0;
            list-style: none;
        }
        /* 提示信息 */
        .noshow{
            height: auto;
            text-align: center;
            margin-top: 166px;
        }
        .noshow>span{
            font-size: 32px;
            color: #999;
        }
        .noshow>p{
            margin-top: 69px;
            margin-bottom: 158px;
            width: 593px;
            height: 349px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
        }
        .noshow>p>img{
            width: 100%;
            height: 100%;
        }
        /* 分页 */
        .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
            background:#f1ad4e;
            color: #fff;
        }
        /* 搜索框 */
        .contentl /deep/ .input-with-select>.el-input__inner{
            background: #f6f6f6;
            color: #a0a0a0;
            font-size: 16px;
        }
        .contentl /deep/ .el-input-group__append button.el-button{
            background-color: #fff;
        }
        /* main */
        .contentl /deep/ .buttontab2>.el-radio-button__inner{
            border: none;
            padding: 0;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
            color: #f1ad4e;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
            background: #fff;
            color: #f1ad4e;
            box-shadow: none;
        }
        .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
            border-left: none;
        }
        .contentl /deep/ .el-button+.el-button{
            margin-left: 20px;
        }
        #unitybox{
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.4);
            z-index: 2001;
        }
        #bo{
            position: relative;
            left: 50%;
            top: 50%;
            right: 0;
            bottom: 0;
            transform: translateX(-50%) translateY(-50%);
            width:1280px;
            height:720px;
        }
        #buttombox{
            position: absolute;
            top: 0;
            right: -51px;
            width: 51px;
            height: auto;
        }
        #full{
            float:left;
            margin: 0;
            padding:5px 15px 3px 15px;
            font-size:20px;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
        }
        #closeun{
            float:left;
            margin: 0;
            padding:5px 16px 3px 16px;
            font-size:20px;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
            cursor: pointer;
            border-bottom:2px solid #eee;
        }
    }
    @media screen and (min-width:1921px) and (max-width:2048px){
        .item{
            width:368px;
            float: left;
            margin: 0.7%;
        }
        .contentl{
            width:97%;
            border-bottom: 1px solid #eee;
            height: 65px;
            margin-left: 10px;
            margin-bottom: 16px;
        }
        .pic{
            height: 207px;
        }
        .contentl>ul{
            height: 65px;
            line-height: 65px;
            margin: 0;
            padding: 0;
            list-style: none;
            float: right;
        }
        .contentl>ul>li{
            width: auto;
            float: left;
            margin: 0;
            padding: 0;
            list-style: none;
        }
        /* 提示信息 */
        .noshow{
            height: auto;
            text-align: center;
            margin-top: 182px;
        }
        .noshow>span{
            font-size: 34px;
            color: #999;
        }
        .noshow>p{
            margin-top: 74px;
            margin-bottom: 122px;
            width: 633px;
            height: 372px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
        }
        .noshow>p>img{
            width: 100%;
            height: 100%;
        }
        /* 分页 */
        .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
            background:#f1ad4e;
            color: #fff;
        }
        /* 搜索框 */
        .contentl /deep/ .input-with-select>.el-input__inner{
            background: #f6f6f6;
            color: #a0a0a0;
            font-size: 16px;
        }
        .contentl /deep/ .el-input-group__append button.el-button{
            background-color: #fff;
        }
        /* main */
        .contentl /deep/ .buttontab2>.el-radio-button__inner{
            border: none;
            padding: 0;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
            color: #f1ad4e;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
            background: #fff;
            color: #f1ad4e;
            box-shadow: none;
        }
        .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
            border-left: none;
        }
        .contentl /deep/ .el-button+.el-button{
            margin-left: 20px;
        }
        #unitybox{
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.4);
            z-index: 2001;
        }
        #bo{
            position: relative;
            left: 50%;
            top: 50%;
            right: 0;
            bottom: 0;
            transform: translateX(-50%) translateY(-50%);
            width:1280px;
            height:720px;
        }
        #buttombox{
            position: absolute;
            top: 0;
            right: -51px;
            width: 51px;
            height: auto;
        }
        #full{
            float:left;
            margin: 0;
            padding:5px 15px 3px 15px;
            font-size:20px;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
        }
        #closeun{
            float:left;
            margin: 0;
            padding:5px 16px 3px 16px;
            font-size:20px;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
            cursor: pointer;
            border-bottom:2px solid #eee;
        }
    }
    @media screen and (min-width:2049px) and (max-width:2560px){
        .item{
            width:464px;
            float: left;
            margin: 0.6%;
        }
        .contentl{
            width:97%;
            border-bottom: 1px solid #eee;
            height: 65px;
            margin-left: 10px;
            margin-bottom: 16px;
        }
        .pic{
            height: 261px;
        }
        .rowtab2{
            position: absolute;
            left: 1150px;
            font-size: 14px;
            margin-top: 32px;
            margin-left: 805px;
        }
        .contentl>ul{
            height: 65px;
            line-height: 65px;
            margin: 0;
            padding: 0;
            list-style: none;
            
            float: right;
        }
        .contentl>ul>li{
            width: auto;
            float: left;
            margin: 0;
            padding: 0;
            list-style: none;
        }
        /* 提示信息 */
        .noshow{
            height: auto;
            text-align: center;
            margin-top: 248px;
        }
        .noshow>span{
            font-size: 44px;
            color: #999;
        }
        .noshow>p{
            margin-top: 92px;
            margin-bottom: 246px;
            width: 791px;
            height: 465px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
        }
        .noshow>p>img{
            width: 100%;
            height: 100%;
        }
        /* 分页 */
        .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
            background:#f1ad4e;
            color: #fff;
        }
        /* 搜索框 */
        .contentl /deep/ .input-with-select>.el-input__inner{
            background: #f6f6f6;
            color: #a0a0a0;
            font-size: 16px;
        }
        .contentl /deep/ .el-input-group__append button.el-button{
            background-color: #fff;
        }
        /* main */
        .contentl /deep/ .buttontab2>.el-radio-button__inner{
            border: none;
            padding: 0;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
            color: #f1ad4e;
        }
        .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
            background: #fff;
            color: #f1ad4e;
            box-shadow: none;
        }
        .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
            border-left: none;
        }
        .contentl /deep/ .el-button+.el-button{
            margin-left: 20px;
        }
        #unitybox{
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.4);
            z-index: 2001;
        }
        #bo{
            position: relative;
            left: 50%;
            top: 50%;
            right: 0;
            bottom: 0;
            transform: translateX(-50%) translateY(-50%);
            width:1760px;
            height:990px;
        }
        #buttombox{
            position: absolute;
            top: 0;
            right: -51px;
            width: 51px;
            height: auto;
        }
        #full{
            float:left;
            margin: 0;
            padding:5px 15px 3px 15px;
            font-size:20px;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
        }
        #closeun{
            float:left;
            margin: 0;
            padding:5px 16px 3px 16px;
            font-size:20px;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            color:#fff;
            z-index: 200;
            cursor: pointer;
            border-bottom:2px solid #eee;
        }
    }
</style>

<style rel="stylesheet/scss" lang="scss">
    .el-message{
        z-index: 2004 !important;
    }
    .page-login-toolTipClass{
        background-color: rgba($color: #333, $alpha: 0.5) !important;
        color: #fff;
        border:none !important;
    }
    .el-tooltip__popper[x-placement^=right] .popper__arrow::after {
        border-right-color: rgba($color: #333, $alpha: 0.5) !important;
    }
    .el-tooltip__popper[x-placement^=right] .popper__arrow{
        border-right-color: rgba($color: #333, $alpha: 0.5) !important;
    }
</style>


// WEBPACK FOOTER //
// src/views/layout/simple/simple1.vue